module.exports = __webpack_public_path__ + "static/media/arrow_2.0d099e4c.svg";